import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=025ae5ce&lang=pug&"
import script from "./TabList.vue?vue&type=script&lang=js&"
export * from "./TabList.vue?vue&type=script&lang=js&"
import style0 from "./TabList.vue?vue&type=style&index=0&id=025ae5ce&prod&module=true&lang=sass&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports